import React from "react";
import { Form, Input, Button, Typography } from "antd";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./login.css";
import registerImage from "../Asset/login.png"; // Replace with your new image path

const { Title } = Typography;

const Register = () => {
  const onFinish = (values) => {
    console.log("Registration Success:", values);
  };

  const shapes = ["circle", "square", "triangle", "star"];

  return (
    <div className="login-tech-wrapper">
      {/* 3D Glow Background */}
      <div className="background-animation"></div>

      {/* Floating Animated Shapes */}
      {[...Array(3)].map((_, index) =>
        shapes.map((shape, i) => (
          <div
            key={`${index}-${i}`}
            className={`floating-shape ${shape} shape-${i + 1}`}
            style={{
              animationDelay: `${Math.random() * 5}s`,
              top: `${Math.random() * 90}%`,
              left: `${Math.random() * 90}%`,
            }}
          >
            {shape === "star" && "★"}
          </div>
        ))
      )}

      {/* Main Layout */}
      <div className="login-container">
        {/* Left Image */}
        <div className="login-image-section">
          <img
            src={registerImage}
            alt="Register Visual"
            className="login-image"
          />
        </div>

        {/* Right Register Card with Animation */}
        <motion.div
          className="login-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Title level={2} className="login-title">
            Register
          </Title>

          <Form name="register" layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Full Name"
              name="fullname"
              rules={[{ required: true, message: "Please enter your name!" }]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please enter your email!" }]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please enter your password!" },
              ]}
            >
              <Input.Password size="large" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block size="large">
                Register
              </Button>
            </Form.Item>

            <div className="login-footer">
              Already have an account? <Link to="/login">Login</Link>
            </div>
          </Form>
        </motion.div>
      </div>
    </div>
  );
};

export default Register;
